import { loadOnetrustSdk } from './load-onetrust-sdk'
import { ConsentProviderConfig } from '../../ports'

export async function loadOnetrustSdkSelfHosted(
  config: ConsentProviderConfig,
  stage: string
): Promise<void> {
  await loadOnetrustSdk(config, stage, true)
}
